import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import 'vue-select/dist/vue-select.css';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import BPCListQueryConfig from '@core/interfaces/bpc-list-query-config';
import { get } from 'lodash';

@Component({
  name: 'bpc-entity-grid',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class EntityGrid extends mixins(AbstractField) {
  $refs!: {
    provider: InstanceType<typeof EntityTableProvider> & {
      getEntities(clearItems?: boolean): void;
      loading: boolean;
      accumulateItems: boolean;
      items: any[];
      pagination: any;
      queryConfig: BPCListQueryConfig;
    };
  };

  @Prop({ type: [String, Number, Boolean, Array, Object], default: null }) readonly value:
    | string
    | number
    | boolean
    | number[]
    | object;
  @Prop(String) readonly selectEntity: string;
  @Prop(String) readonly selectValue: string;
  @Prop(Array) readonly filters: any[];
  @Prop({ type: String, default: 'table' }) readonly displayConfigName: string;
  @Prop({
    type: Array,
    default() {
      return ['default'];
    },
  })
  readonly selectConfigName: string;
  @Prop({ type: String, default: null }) readonly completeWithExtraData: string;
  @Prop(String) readonly orderBy: string;
  @Prop(String) readonly orderDirection: string;
  @Prop({
    type: Array,
    default: () => ['configLoaded', 'paginationLoaded', 'orderLoaded'],
  })
  readonly customFlagsToCheckBeforeLoadEntities: Array<any>;

  public entity = null;

  constructor() {
    super();
  }

  get model(): any {
    return this.value;
  }
  set model(val: any) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  mounted() {
    if (this.orderBy) {
      this.$refs.provider.queryConfig.params.orderBy = this.orderBy;
    }
    if (this.orderDirection) {
      this.$refs.provider.queryConfig.params.orderDirection = this.orderDirection;
    }
  }

  // destroyed() {}

  async itemsLoaded() {
    if (this.completeWithExtraData) {
      if (this.$refs.provider.items[0].id === this.value) {
        this.model = this.$refs.provider.items[0];
      } else {
        this.model = null;
      }
    }
  }

  extendHandleEvent(eventName: string, event: any, val: any) {
    if (event.filters) {
      event.filters.forEach(filter => {
        if (filter.strictValue) {
          this.$set(this.$refs.provider.queryConfig.params, filter.field, filter.value);
        } else if (!filter.value) {
          this.$set(this.$refs.provider.queryConfig.params, filter.field, val);
        } else {
          this.$set(
            this.$refs.provider.queryConfig.params,
            filter.field,
            get(val, filter.value, val),
          );
        }
      });
    }
    if (event.action === 'getEntities') {
      this.$refs.provider.items = [];
      this.model = null;
      this.$refs.provider.getEntities();
    }
    if (event.action === 'refreshOptions') {
      this.model = null;
    }
    if (event.action === 'setExtraData') {
      this.$set(this.extraData, event.propertyPath, val);
    }
    if (event.action === 'selectEntity') {
      // Only works for single selects (if receive more entities does not take anything)
      const itemIdFromEvent = Array.isArray(val)
        ? val.length === 1
          ? val[0]?.[`${event.entity}_id`]
          : null
        : val?.[`${event.entity}_id`];
      this.model = itemIdFromEvent;
      setTimeout(() => {
        if (this.$refs.provider.pagination.current_page != 1) {
          this.$refs.provider.pagination.current_page = 1;
        } else {
          this.$refs.provider.getEntities();
        }
      });
    }
  }

  get entityId() {
    return this.entity?.id ? this.entity.id : null;
  }

  onClick(id = null) {
    this.model = id;
  }

  get smCols() {
    return this.$attrs.gridCols && this.$attrs.gridCols['sm'] ? this.$attrs.gridCols['sm'] : '12';
  }

  get mdCols() {
    return this.$attrs.gridCols && this.$attrs.gridCols['md'] ? this.$attrs.gridCols['md'] : '4';
  }

  get lgCols() {
    return this.$attrs.gridCols && this.$attrs.gridCols['lg'] ? this.$attrs.gridCols['lg'] : '4';
  }
}
